@let node = rowNode();

<!--
    The classes `appButton` would give it (sm, text, dark, rounded, icon-only).
    `appButton` itself is not used: it always sets `aria-pressed`, which would
    announce this disclosure button as a toggle button as well.
-->
<button
    type="button"
    class="btn btn-sm btn-icon btn-text-dark rounded-pill"
    [class.invisible]="!node.hasChildren"
    [attr.aria-expanded]="node.hasChildren ? node.isExpanded : null"
    [attr.aria-label]="(node.isExpanded ? 'TABLE.TREE.COLLAPSE_ROW' : 'TABLE.TREE.EXPAND_ROW') | translate: { name: rowLabel() }"
    (click)="onToggle()"
>
    @if (node.isExpanded) {
        <i class="fa-chevron-down fa-regular fa-lg" aria-hidden="true"></i>
    }
    @else {
        <!-- `rtl-icon-handler` turns it to point left in RTL; it would turn the down chevron upside down -->
        <i class="fa-chevron-right fa-regular fa-lg rtl-icon-handler" aria-hidden="true"></i>
    }
</button>
